import { oz } from '@weft/utils';

export const CustomerExternalSchema = oz.object({
  name: oz.string().min(1),
  alias: oz.string().min(1).optional(),
}).openapi('CustomerExternal');

export type CustomerExternal = oz.infer<typeof CustomerExternalSchema>;